var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Box, Button, Copy, H6, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './SignupForUpdates.styles';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
var SuccessContainer = themeStyles.apply(Box, 'FormSubmissionResultContainer');
var ExploreButton = themeStyles.apply(Button, 'ExploreButton');
var SuccessUI = function (_a) {
    var _b;
    var ctaButton = _a.ctaButton;
    var t = useTranslation().t;
    return (React.createElement(SuccessContainer, { "data-testid": "cy-success-container" },
        React.createElement(H6, { mb: "m", "data-testid": "cy-success-title" }, t('Shared.SignUp.successHeading')),
        React.createElement(Copy, { size: "regular", mb: "l", "data-testid": "cy-success-description" }, t('Shared.SignUp.submissionSuccess')),
        React.createElement(Optional, { when: (_b = ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.ctaLink) === null || _b === void 0 ? void 0 : _b.href },
            React.createElement(ExploreButton, { width: "max-content", "data-testid": "cy-success-cta", styling: ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.styling, as: RoutableSitecoreLink, field: {
                    value: __assign({}, ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.ctaLink),
                } }))));
};
export default SuccessUI;
